module.exports = __webpack_public_path__ + "img/17_52.3c0d4870.png";